import React, { ReactElement } from 'react'
import { Picture, PictureSizeDefinition } from '@/components/common/picture/Picture'
import { Sizes } from '@/components/common/picture/Sizes'
import ImageSliderClientComponent, {
  ImageSliderProps,
} from '@/components/ui/search/image-slider/ImageSliderClientComponent'

export const LANDING_PAGE_SIZES: PictureSizeDefinition = {
  [Sizes.xs]: [280, 599, 200],
  [Sizes.sm]: [600, 727, 200],
  [Sizes.md]: [728, 983, 200],
  [Sizes.lg]: [312, 315, 200],
  [Sizes.xl]: [397, 397, 200],
}

export const SEARCH_PAGE_SIZES_MAP_SEARCH_RESULT: PictureSizeDefinition = {
  [Sizes.xs]: [280, 599, 224],
  [Sizes.sm]: [600, 727, 224],
  [Sizes.md]: [704, 704, 224],
  [Sizes.lg]: [704, 704, 224],
  [Sizes.xl]: [704, 704, 224],
}
export const SEARCH_PAGE_SIZES: PictureSizeDefinition = {
  [Sizes.xs]: [282, 601, 224],
  [Sizes.sm]: [602, 729, 224],
  [Sizes.md]: [722, 977, 224],
  [Sizes.lg]: [411, 520, 224],
  [Sizes.xl]: [350, 350, 224],
}
export const POPUP_SIZES: PictureSizeDefinition = {
  [Sizes.xs]: [200, 200, 152],
  [Sizes.sm]: [200, 200, 152],
  [Sizes.md]: [200, 200, 152],
  [Sizes.lg]: [200, 260, 152],
  [Sizes.xl]: [260, 260, 152],
}
export const MODAL_ROOM_SIZES: PictureSizeDefinition = {
  [Sizes.xs]: [599, 599, 152],
  [Sizes.sm]: [727, 727, 152],
  [Sizes.md]: [704, 704, 300],
  [Sizes.lg]: [704, 704, 300],
  [Sizes.xl]: [704, 704, 300],
}

export default function ImageSlider(props: ImageSliderProps): ReactElement {
  const pictures = props.images.map((image) => (
    <Picture
      key={image}
      src={image}
      alt={props.alt}
      size={props.pictureSizeDefinition}
      openPageURL={props.href}
      openInNewWindow={props.openInNewWindow}
      cornerRounding="rounded-none"
    />
  ))
  return <ImageSliderClientComponent {...props} pictures={pictures} onClick={props.onClick} />
}
